import React, { useState } from "react"
import { Button, Input, message, Space } from "antd"
import { refreshData } from "../../../../../../services/dct/DctService"

const Refresh = ()=> {
  const [loading, setLoading] = useState(false)
  const [subjectCode, setSubjectCode] = useState('')

  const handleRefresh = async()=> {

    setLoading(true)

    const { code, message: msg } = await refreshData({
      subjectCode: subjectCode || null
    })

    setLoading(false)

    if (code === 0) {
      message.success("刷新成功")
      setSubjectCode('')
    }
  }

  return (
    <Space direction="horizontal">
        <Input value={subjectCode} onChange={({ target })=> setSubjectCode(target.value)} placeholder="受试者编号(非必填)"/>
        <Button loading={loading} onClick={handleRefresh} type='primary'>刷新终审数据</Button>
    </Space>
  )
}

export default Refresh
